var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.value)?_c('span',[_vm._v(_vm._s(_vm.extractFileName(_vm.value.file)))]):_vm._e(),_c('FileUpload',{ref:"upload",style:({ display: _vm.isVisible ? 'block' : 'none' }),attrs:{"accept":_vm.accept},on:{"input":_vm.upload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }